// extracted by mini-css-extract-plugin
export default {"cellDisabled":"DataTable_cellDisabled__LXoon","cellEnabled":"DataTable_cellEnabled__-u71O","loading":"DataTable_loading__JN64h","progress":"DataTable_progress__mC8E8"};